import React from 'react'

import Button, { ButtonVariant } from '../../components/ui/button'
import InvoiceOverlayModal from '../../components/modals'
import { ProfileOverwriteChoice } from '../../lib/guestHydrationOrchestrator'

type Props = {
  open: boolean
  onChoose: (choice: ProfileOverwriteChoice) => void
  disableDismiss?: boolean
}

const ProfileOverwritePrompt: React.FC<Props> = ({ open, onChoose, disableDismiss = false }) => (
  <InvoiceOverlayModal
    open={open}
    onClose={() => {
      if (disableDismiss) return
      onChoose('decline')
    }}
    title='Update your business profile?'
    description='Your saved business details differ from what you entered on the guest invoice.'
  >
    <p className='mb-4'>
      Replace your profile with the guest invoice details, or keep your saved profile and use it on this invoice instead.
    </p>
    <div className='d-flex flex-column flex-sm-row justify-content-end gap-2'>
      <Button type='button' variant={ButtonVariant.LIGHT} onClick={() => onChoose('decline')}>
        Keep saved profile
      </Button>
      <Button type='button' variant={ButtonVariant.PRIMARY} onClick={() => onChoose('accept')}>
        Use guest details
      </Button>
    </div>
  </InvoiceOverlayModal>
)

export default ProfileOverwritePrompt
